import * as XLSX from 'xlsx'

export interface XlsxColumn {
  title: string
  key: string
}

export function downloadXlsx(
  filename: string,
  sheetName: string,
  headers: XlsxColumn[],
  rows: Record<string, string | number | null>[]
): void {
  const aoa: (string | number)[][] = [
    headers.map((h) => h.title),
    ...rows.map((row) => headers.map((h) => row[h.key] ?? '')),
  ]

  const worksheet = XLSX.utils.aoa_to_sheet(aoa)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)
  XLSX.writeFile(workbook, filename)
}
